export default "__VITE_ASSET__xUGEsEZM__"